module.exports = __webpack_public_path__ + "static/media/we_found_car_once.95d44eb3.gif";